const feedbackSlider = () => {
  $('.js-feedback-slider').slick({
    draggable: true,
    autoplay: true,
    autoplaySpeed: 5000,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 3,
    touchThreshold: 1000,
    arrows: false,
    responsive: [{
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }]
  });
};

export default feedbackSlider;
